/* eslint-disable @typescript-eslint/naming-convention */
import axiosInstanceApiGateway from 'config/apiServiceApiGateway'
import type {
  QuotaDailyResponseType,
  QuotaHistoryResponseType,
  QuotaDateRangeResponseType,
  QuotaFormulaResponseType,
  QuotaFormulaPayloadType,
  QuotaManualAddPayloadType,
} from '../redux/Quota3PL/types'

const { Get, Put } = axiosInstanceApiGateway

export const GetHubQuota = (payload: { locationId: number; selectedTimestamp: number }) =>
  Get<QuotaDailyResponseType>({
    url: `/logistic/internal/v1/external-driver/${payload.locationId}/quota/daily`,
    params: {
      date_timestamp: payload.selectedTimestamp,
    },
  })
export const getHistoryQuota = (params: {
  'pagination.limit': number
  'pagination.offset': number
}) =>
  Get<QuotaHistoryResponseType>({
    url: `/logistic/internal/v1/external-driver/quota/histories`,
    params,
  })

export const getQuotaDateRange = (locationId: number) =>
  Get<QuotaDateRangeResponseType>({
    url: `/logistic/internal/v1/external-driver/quota/date-range`,
    params: { location_id: locationId },
  })

export const getQuotaFormula = (params: {
  location_id: number
  start_timestamp: number
  end_timestamp: number
  start_hour?: string[]
}) =>
  Get<QuotaFormulaResponseType>({
    url: `/logistic/internal/v1/external-driver/${params.location_id}/quota/formula`,
    params: {
      start_timestamp: params.start_timestamp,
      end_timestamp: params.end_timestamp,
      start_hour: params.start_hour,
    },
  })

export const putQuotaFormula = (payload: QuotaFormulaPayloadType) => {
  const { location_id, ...rest } = payload
  return Put({
    url: `/logistic/internal/v1/external-driver/${location_id}/quota/formula`,
    data: {
      ...rest,
    },
  })
}

export const putAddManualQuota = (payload: QuotaManualAddPayloadType) =>
  Put({
    url: `/logistic/internal/v1/external-driver/quota/add`,
    data: {
      ...payload,
    },
  })

export const getQuotaHourlyHub = (payload: { locationId: string }) =>
  Get<{ start_time: number; end_time: number; available_quota: number }, true>({
    url: `/logistic/internal/v1/external-driver/${payload.locationId}/quota/hourly`,
  })
